export default __webpack_public_path__ + "assets/icons/clear.b5d68cd4.svg";